import React, { useState } from "react";
import "./ForgetPassword.css";
import HttpCommon from "../../Utils/http-common";
import swal from "sweetalert";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { ForgetPasswordValidation } from "../../From/Validation";
import FormGroup from "../../Components/Common/FormGroup";
import InputField from "../../Components/Common/InputField";

const ForgetPassword = () => {
  const [check, setCheck] = useState(false);
  const [forgetPasswordForm, setForgetPasswordForm] = useState(true);
  const [showUserAccounts, setShowUserAccounts] = useState(false);
  const [isLoadingAccounts, setIsLoadingAccounts] = useState(false);
  const [userArray, setUserArray] = useState([]);
  const navigate = useNavigate();
  const theme = useTheme();

  const initialValues = {
    email: "",
  };

  const handleSubmit = async (values, { setSubmitting, setFieldError, resetForm }) => {
    if (!check) {
      try {
        const res = await HttpCommon.post("/user/forgotpassword", { email: values.email });
        if (res.data.success) {
          swal("Email Sent!", typeof res?.data?.data === "string" ? res?.data?.data : "Check your inbox.", "success");
          resetForm();
        } else {
          setFieldError("email", "Email Address is not found");
        }
      } catch (error) {
        console.error(error);
        if (error.code === "ERR_NETWORK") {
          swal("Network Error!", "Failed to connect server.", "error");
          return;
        }
        swal("Failed!", "Failed to send email.", "error");
      }
    }
    setSubmitting(false);
  };

  const handleContinue = async (values, { setSubmitting, setFieldError }) => {
    if (!values.email) {
      setFieldError("email", "Email Address is required");
      setSubmitting(false);
      return;
    }

    try {
      const res = await HttpCommon.post("/subUser/checkEmail", { email: values.email });
      if (res.data.status === "success") {
        setForgetPasswordForm(false);
        setShowUserAccounts(true);
        setIsLoadingAccounts(true);
        
        const subUsersRes = await HttpCommon.post("/subUser/getSubUsersviaEmail", {
          email: values.email,
        });
        setUserArray(subUsersRes.data.data);
        setIsLoadingAccounts(false);
      } else {
        setFieldError("email", "Invalid username. Email does not exists");
      }
    } catch (err) {
      console.error(err);
      if (err.code === "ERR_NETWORK") {
        swal("Network Error!", "Failed to connect server.", "error");
      }
    }
    setSubmitting(false);
  };

  const sendSubUserForgotPasswordEmail = async (email, petOwner) => {
    const value = {
      email: email,
      petOwner: petOwner,
    };
    
    const res = await HttpCommon.post("/subUser/forgotPassword", value);
    return res;
  };

  const subUserSubmit = async (userId, email) => {
    if (email === "" || userId === "") {
      return;
    }

    try {
      const res = await sendSubUserForgotPasswordEmail(email, userId);
      
      if (res.data.success) {
        await swal("Email Sent!", "Check your inbox.", "success");
        window.location.reload();
      } else {
        swal("Error!", "Email Address is not found", "error");
      }
    } catch (err) {
      console.error(err);
      if (err.code === "ERR_NETWORK") {
        swal("Network Error!", "Failed to connect server.", "error");
        return;
      }
      swal("Failed!", "Failed to send email.", "error");
    }
  };

  return (
    <div className="main">
      {forgetPasswordForm && (  
        <div className="container-forget">
          <Formik
            initialValues={initialValues}
            validationSchema={ForgetPasswordValidation}
            onSubmit={!check ? handleSubmit : handleContinue}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue ,getFieldProps}) => (
              <Form>
                <h1>Forgot Password</h1>
                <br />

                <FormGroup
                label="Enter Your Email"
                name="email"
                className="loginField"
                svgPath={require("../../Assets/Images/mail-account.png")}
                requiredField
              >
                <InputField
                  type="text"
                  name="email"
                  className="textarea"
                  {...getFieldProps("email")}
                />
              </FormGroup>
                {/* <div className="left">
                  <input
                    type="checkbox"
                    id="check"
                    onChange={() => {
                      setCheck(!check);
                    }}
                    checked={check}
                  />
                  <label for="check"> Sub user account</label>
                </div> */}
            
                {!check ? (
                  <button 
                    type="submit" 
                    className="btn1-forget" 
                    disabled={isSubmitting}
                    style={{backgroundColor: `${theme.palette.primary.main}`}}
                  >
                    {isSubmitting ? "Sending..." : "Send email"}
                  </button>
                ) : (
                  <button 
                    type="submit" 
                    className="btn1-forget" 
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Checking..." : "Continue"}
                  </button>
                )}

                <br />
                <p id="account" style={{ margin: 0, padding: 0}}>or</p>
                <p 
                  id="l4" 
                  style={{ paddingTop: "10px", fontSize: "18px", cursor: "pointer", margin: 0}} 
                  onClick={() => {
                    navigate("/account");
                  }}
                >
                  Login
                </p>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {showUserAccounts && (
        <div className="container">
          <form style={{ paddingBottom: 30 }}>
            <h1>Select the pet owner</h1>

            <br />
            {isLoadingAccounts ? (
              <h3>Loading your data...</h3>
            ) : (
              userArray.map((user, i) => (
                <Card
                  onClick={() => {
                    subUserSubmit(user.userId, user.userEmail);
                  }}
                  key={i}
                >
                  {user.userImage === null ? (
                    <img
                      src={require("../../Assets/Images/profile.png")}
                      alt="ProfileLogo"
                    />
                  ) : (
                    <img src={user.userImage} alt="ProfileLogo" />
                  )}

                  <Name>
                    {user.userFirstName} {user.userLastName}
                  </Name>
                  <Email>{user.userEmail}</Email>
                </Card>
              ))
            )}
          </form>
        </div>
      )}
    </div>
  );
};

export default ForgetPassword;

const Card = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid #249fda;
  border-radius: 20px;
  justify-content: left;
  align-items: center;
  margin-bottom: 20px;
  padding: 5px 20px 5px 20px;
  :hover {
    box-shadow: 10px 10px 10px gray;
    transition: 0.3s;
  }
  img {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    margin-right: 40px;
  }
`;
const Name = styled.h3`
  width: 250px;
  margin-right: 20px;
`;
const Email = styled.h3``;
